import { canCreatePsAttempt } from './canCreatePsAttempt';
import type { ExtendedUserResponseSchema } from '@/types/user.types';

/**
 * View permission for Process Service attempt screens (including HI-inclusive first-attempt view).
 * Mirrors create gating: admin/supervisor or SERVICE team.
 */
export const canViewPsAttempt = (user: ExtendedUserResponseSchema | null): boolean =>
  canCreatePsAttempt(user);
